module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/plan_type_chapel@2x-e034e6f14ecadedc71d5f376f33e2a21.webp";